function Union({  color = '#959FAF' }) {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.02105 5.14737C7.75263 4.87895 7.26316 4.87895 6.99474 5.14737L4.15263 7.98947C3.86842 8.27368 3.86842 8.73158 4.15263 9.01579C4.43684 9.3 4.89474 9.3 5.17895 9.01579L7.5 6.69474L9.82105 9.01579C9.96316 9.15789 10.1526 9.23684 10.3421 9.23684C10.5316 9.23684 10.7211 9.15789 10.8632 9.01579C11.1474 8.73158 11.1474 8.27368 10.8632 7.98947L8.02105 5.14737Z" fill={color} />
      <path d="M7.5 2.98004e-07C3.36316 -6.36507e-08 1.971e-06 3.36316 1.60935e-06 7.5C1.24769e-06 11.6368 3.36316 15 7.5 15C11.6368 15 15 11.6368 15 7.5C15 3.36316 11.6368 6.59658e-07 7.5 2.98004e-07ZM7.5 13.5474C4.16842 13.5474 1.45263 10.8316 1.45263 7.5C1.45263 4.16842 4.16842 1.45263 7.5 1.45263C10.8316 1.45263 13.5474 4.16842 13.5474 7.5C13.5474 10.8316 10.8316 13.5474 7.5 13.5474Z" fill={color} />
    </svg>

  );
}

export default Union;
